import InfoPanel from '@/components/common/InfoPanel/InfoPanel'
import InfoItem from '@/components/common/InfoItem/InfoItem'

export default function CustomerInformation({storeData, handleCustomerClick}) {
  // Check if customerInformation exists, if not use an empty object
  const customerInfo = storeData?.customerInformation || {};
  
  return (
    <InfoPanel title="Customer Information" isCollapsible={false} defaultOpen={false} className="mt-4 !px-0">
      <div className="px-4">
        <div className="grid grid-cols-3 gap-y-6">
          <InfoItem
            label="Customer ID"
            value={customerInfo?.customerId || '-'}
            onClick={() => customerInfo?.customerId && handleCustomerClick(customerInfo?.customerId)}
            className={customerInfo?.customerId ? "cursor-pointer text-blue-800 hover:underline" : ""}
            // className={"text-blue-800"}

          />
          <InfoItem label="Customer User ID" value={customerInfo?.customerUserId || '-'} />
          <InfoItem label="Customer Name" value={customerInfo?.customerName || '-'} />
  
          <InfoItem label="Login Name" value={customerInfo?.loginName || '-'} />
          <InfoItem label="Customer Type" value={customerInfo?.customerType || '-'} />
          <InfoItem label="Pace ID" value={customerInfo?.paceId || '-'} />
        </div>
      </div>
    </InfoPanel>
  )
}